import PlantType from 'types/PlantType'

export interface PlantBadgeProps {
  type: PlantType
}

export const usePlantBadge = (props: PlantBadgeProps) => {
  return {
    ...props,
  }
}
